import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UtileriasService {

  /**
     * Método que convierte a número la cadena proporcionada, si ocurre un error regesa -1
     * @param valor // Cadena
     */
    convertirANumero(valor: string): number {
        if (valor != null && valor !== undefined && valor.trim() !== '') {
            try {
                const numero = Number(valor);
                return !Number.isNaN(numero) ? numero : -1;
            } catch (e) {
                return -1;
            }
        } else {
            return -1;
        }
    }

    public validarListaVacia(lista: any[]): boolean {
        if (lista == null || lista === undefined) {
            return true;
        }

        if (lista.length <= 0) {
            return true;
        }

        return false;
    }

    public validarNumero(valor: number): boolean {
        if (valor === null || valor === undefined) {
            return false;
        }
        if (Number.isNaN(valor) || valor === Infinity) {
            return false;
        }

        if (valor <= 0) {
            return false;
        }
        return true;
    }

    public validarVacio(valor: string): boolean {
        if (valor === null || valor === undefined) {
            return true;
        }
        if (valor.trim() === '') {
            return true;
        }
        return false;
    }

    public validarcodigoError(codigo: any): boolean {
        const numero = this.convertirANumero(codigo);
        if (numero < 0 || numero > 0) {
            return false;
        }
        return true;
    }

    public obtenerPagina(inicio: number, size: number, total: number): number {
        if (inicio === 0) {
            return 0;
        }

        let maxPage: number = total > 0 ? (total / size) : 0;
        const residuo: boolean = (total % size) > 0 ? true : false;
        maxPage = residuo ? (maxPage + 1) : maxPage;

        let numPagina: number = this.obtenerNumeroPagina(inicio, size);
        numPagina = this.validarNumeroPagina(maxPage, numPagina);
        return numPagina;
    }

    private obtenerNumeroPagina(inicio: number, size: number) {
        return inicio / size;
    }

    private validarNumeroPagina(maxPage: number, page: number): number {
        if ((page + 0) > maxPage) {
            page = maxPage - 1;
        }

        if (page < 0) {
            page = 0;
        }
        return page;
    }

    public validarObjecto(objeto: any): boolean {
        if (objeto === null || objeto === undefined) {
            return false;
        }
        return true;
    }

}
